'use client';

var _jsxFileName = "/builds/zillow/hackweek/military-rent-affordability-calculator/src/components/MilitaryRentAffordabilityCalculator/mrac-page-content/index.jsx",
    _this = this;

import React from 'react';
import styled from 'styled-components';
import { Page, spaceMixin } from '@zillow/constellation';
import IncomeDebtForm from '../mrac-income-debt-form';
var PageWithPadding = styled(Page).withConfig({
  displayName: "mrac-page-content__PageWithPadding",
  componentId: "sc-o46w2t-0"
})(["padding:", ";"], spaceMixin('xl'));

var MRACPageContent = function MRACPageContent() {
  return /*#__PURE__*/React.createElement(PageWithPadding, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(IncomeDebtForm, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 9
    }
  }));
};

export default MRACPageContent;